import React, { Component } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { BILLING_TYPE_IDS, featureList, itemInvoiceTypeAddInfos, invoiceItemTypeIds } from '../../../../constants'
import Icon from '../../Icon'
import { Hidden } from '../../../Shared/Grid'

class InvoiceOrderItems extends Component {
  getStylingClassNamesByInvoiceItemTypeId (invoiceItemTypeId) {
    const classNames = []

    const shouldHighlight = [7, 8, 10].includes(invoiceItemTypeId)
    if (shouldHighlight) classNames.push('invoice-highlight-row')

    const shouldTotalUp = [10].includes(invoiceItemTypeId)
    if (shouldTotalUp) classNames.push('invoice-total-up-row')

    const isDiscount = [4, 5, 11, 12].includes(invoiceItemTypeId)
    if (isDiscount) classNames.push('invoice-discount-row')

    return classNames
  }

  createItemRow (key, item) {
    const { t } = this.props
    if (!this.props.orderAdditionalData || this.props.orderAdditionalData.hasOwnProperty('items') === false ||
      this.props.orderAdditionalData.items.hasOwnProperty(item.id) === false) {
      console.error('Missing additional data for id ' + item.id)
      return
    }
    let additionalData = this.props.orderAdditionalData.items[item.id]
    return <tr key={'item_row_' + key}>
      <td data-title={'GIATA-ID'}>{additionalData.giataId}</td>
      <td data-title={t('HOTEL')}>{additionalData.hotelName}</td>
      <td data-title={t('CITY')}>{additionalData.cityName}</td>
      <td data-title={t('COUNTRY')}>{additionalData.countryName}</td>
      <td data-title={t('NUMBER_OF_ROOMS')}>{additionalData.numberOfRooms}</td>
    </tr>
  }

  createResultRow (item) {
    const { t } = this.props

    let positionCounter = 0
    return item.positions.map((product) => {
      let key = item.id + '_' + positionCounter
      let oneTime = product.billingTypeId === BILLING_TYPE_IDS.nonrecurring
      let fragment
      const highlightedProduct = [invoiceItemTypeIds.basicFeatures, invoiceItemTypeIds.additionalFeatures].includes(product.invoiceItemTypeId)
      let addProductTitleText = null
      if (itemInvoiceTypeAddInfos.hasOwnProperty(product.invoiceItemTypeId)) {
        addProductTitleText = <div className={'order-confirm-product-desc'}>
          {t(itemInvoiceTypeAddInfos[product.invoiceItemTypeId].addTitle)}
        </div>
      }
      let classNames = []
      if (highlightedProduct) {
        classNames.push('order-item-highlighted-text')
      }
      if (positionCounter === 0) {
        fragment = <tr key={key} className={classNames.join(' ')}>
          <td data-title={t('PRODUCT')}>
            {t('INVOICE_ITEM_ID_' + product.invoiceItemTypeId)}
            {addProductTitleText}
          </td>
          <td
            data-title={t('PRICE')}
            className={'clearfix'}>
            <div className={'td-content'} style={{ display: 'flex' }}>
              <span>{t('RENDER_PRICE', { value: product.price / 100 })}</span>
              {oneTime && <span className={'tooltip-icon'}>
              <Icon
                size={'small'}
                type={'info'}
                tooltip={t('BILLING_ONE_TIME_DESCRIPTION')}/>
              </span>}
            </div>
          </td>
          <td data-title={t('QUANTITY')}>{product.amount}</td>
          <td
            data-title={t('TOTAL')}
            className={'clearfix'}>
            <div className={'td-content'} style={{ display: 'flex' }}>
              <span>{t('RENDER_PRICE', { value: product.total / 100 })}</span>
              {oneTime && <span className={'tooltip-icon'}>
              <Icon
                size={'small'}
                type={'info'}
                tooltip={t('BILLING_ONE_TIME_DESCRIPTION')}/>
              </span>}
            </div>
          </td>
        </tr>
      } else {
        fragment = <tr key={key} className={classNames.join(' ')}>
          <td data-title={t('PRODUCT')}>{t('INVOICE_ITEM_ID_' + product.invoiceItemTypeId)} {addProductTitleText}
          </td>
          <td data-title={t('PRICE')}>{t('RENDER_PRICE', { value: product.price / 100 })}</td>
          <td data-title={t('QUANTITY')}>{product.amount}</td>
          <td data-title={t('TOTAL')}>{t('RENDER_PRICE', { value: product.total / 100 })}</td>
        </tr>
      }

      positionCounter++
      if (
        itemInvoiceTypeAddInfos.hasOwnProperty(product.invoiceItemTypeId)
        && itemInvoiceTypeAddInfos[product.invoiceItemTypeId].features.length > 0) {
        const features = itemInvoiceTypeAddInfos[product.invoiceItemTypeId].hasOwnProperty('addFeatures') ? itemInvoiceTypeAddInfos[product.invoiceItemTypeId].addFeatures : itemInvoiceTypeAddInfos[product.invoiceItemTypeId].features
        return <React.Fragment key={key + '_features'}>
          {fragment}
          <tr>
            <td colSpan={4}>{
              features.map((featureId) => {
                return <p key={key + '_features_' + featureId}>
                  {t(featureList[featureId].title)}
                </p>
              })}</td>
          </tr>
        </React.Fragment>
      }
      return fragment
    })
  }

  createResultRowBill (key, billPosition) {
    const { t } = this.props
    let classNames = this.getStylingClassNamesByInvoiceItemTypeId(billPosition.invoiceItemTypeId)
    return (
      <tr key={'balance_' + key} className={classNames.join(' ')}>
        <td>
          {t('INVOICE_ITEM_ID_' + billPosition.invoiceItemTypeId, { addition: billPosition.addition })}
        </td>
        <td>{t('RENDER_PRICE', { value: billPosition.value / 100 })}</td>
      </tr>
    )
  }

  createResultTdFollowUp (key, billPosition) {
    const { t } = this.props
    return (
      <React.Fragment key={'followUp_' + key}>
        <td>
          {t('RENDER_PRICE', { value: billPosition.value / 100 })} {billPosition.invoiceItemTypeId === 9 && t('INVOICE_ITEM_ID_' + billPosition.invoiceItemTypeId, { addition: billPosition.addition })}
        </td>
        {key === 0 && <Hidden xs sm md><td>&nbsp;</td></Hidden>}
      </React.Fragment>
    )
  }

  render () {
    const { t } = this.props
    return (
      <React.Fragment>
        <div className="flex-table order-items">
          <div>
            <div className="table-responsive-vertical" style={{ position: 'relative' }}>
              <table className="table table-hover">
                <thead>
                <tr>
                  <td>GIATA-ID</td>
                  <td>{t('HOTEL')}</td>
                  <td>{t('CITY')}</td>
                  <td>{t('COUNTRY')}</td>
                  <td>{t('NUMBER_OF_ROOMS')}</td>
                </tr>
                </thead>
                <tbody>
                {this.props.bill.items.map((v, key) => this.createItemRow(key, v))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="table-responsive-vertical" style={{ position: 'relative' }}>

            <table className="table table-hover order-item-product-table">
              <thead>
              <tr>
                <td>{t('PRODUCT')}</td>
                <td>{t('PRICE')}</td>
                <td>{t('QUANTITY')}</td>
                <td>{t('TOTAL')}</td>
              </tr>
              </thead>
              <tbody>
              {this.props.bill.items.map((v) => this.createResultRow(v))}
              </tbody>
            </table>
          </div>
          <hr style={{ margin: '0 28px' }}/>
          <div className="table-responsive-vertical order-item-product-table-billing" style={{ position: 'relative' }}>
            <table className="table table-hover">
              <tbody>
              {this.props.bill.balance.map((v, key) => this.createResultRowBill(key, v))}
              </tbody>
            </table>
          </div>
          {this.props.showFollowUp &&
            <div className="table-responsive-vertical" style={{ position: 'relative' }}>
              <table className="table table-hover order-confirm-table-follow-up">
                <tbody>
                {/*<tr className={'invoice-highlight-row follow-up-row'}>*/}
                {/*  <td colSpan={2}>{t('FOLLOW_UP_PRICE')}</td>*/}
                {/*</tr>*/}
                <tr>
                  <td colSpan={1}>{t('FOLLOW_UP_PRICE')}</td>
                  {this.props.bill.followUp.map((v, key) => this.createResultTdFollowUp(key, v))}
                </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

const additionalOrderItemData = PropTypes.shape({
  items: PropTypes.objectOf(PropTypes.shape({
    giataId: PropTypes.number.isRequired,
    numberOfRooms: PropTypes.number.isRequired,
    features: PropTypes.array.isRequired,
    hotelName: PropTypes.string.isRequired,
    cityName: PropTypes.string.isRequired,
    countryName: PropTypes.string.isRequired
  })).isRequired,
})

const invoicePosition = PropTypes.shape({
  invoiceItemTypeId: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  billingTypeId: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
})

let billShape = PropTypes.shape({
  // key = giataId
  items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      positions: PropTypes.arrayOf(invoicePosition).isRequired,
      total: PropTypes.number.isRequired
    })
  ).isRequired,
  balance: PropTypes.arrayOf(PropTypes.shape({
    invoiceItemTypeId: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    addition: PropTypes.any,
  })).isRequired,
  followUp: PropTypes.arrayOf(PropTypes.shape({
    invoiceItemTypeId: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    addition: PropTypes.any
  }))
})

InvoiceOrderItems.defaultProps = {
  showFollowUp: true
}

InvoiceOrderItems.propTypes = {
  bill: billShape.isRequired,
  orderAdditionalData: additionalOrderItemData.isRequired,
  showFollowUp: PropTypes.bool

}
export default withTranslation()(InvoiceOrderItems)
